export const SET_PURCHASE_PLACES = 'SET.PURCHASE.PLACES';
export const SET_PURCHASE_PLACES_LOADING = 'SET.PURCHASE.PLACES.LOADING';
export const UNSET_PURCHASE_PLACES_LOADING = 'UNSET.PURCHASE.PLACES.LOADING';
export const SET_SERIAL_NUMBER_MANDATORY = 'SET.SERIAL.NUMBER.MANDATORY';
